import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  resolveHubForLegacySubTab,
  DOCUMENT_HUBS,
} from '@/pages/documents/shared/tab-resolver';

// Redirect compat: i deeplink legacy `/documents/new?subTab=*` vengono
// dirottati al `new` dell'hub corretto preservando il subTab.
export const Route = createFileRoute(
  '/protected/_layout/documents/_layout/new'
)({
  beforeLoad: ({ search }) => {
    const targetHub =
      resolveHubForLegacySubTab(search.subTab ?? undefined) ??
      DOCUMENT_HUBS.invoices;
    // TanStack Router non riesce a inferire il tipo literale per path
    // composti dinamicamente (basePath + 'new') — il path è valido a runtime.
    throw redirect({
      to: `${targetHub.basePath}/new`,
      search,
    } as never);
  },
  component: () => null,
});
